/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-name[_ngcontent-%COMP%]{font-size:18px;font-weight:500;margin:5px 0;cursor:pointer}"];
export { styles as styles };
